import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import customModal from "../customModal/customModal.vue";
import discrepancyModal from "../SDV_Discrepancymodal/SDV_Discrepancymodal.vue";
import { get } from "jquery";
import { Subject } from "@microsoft/signalr";

export default {
  name: 'sdvVerificationModal',
  props: {
    id:{
      type: String,
      default: '',
    },
    modalType: {
      type: String,
      default: 'doSDV', 
    },
    fromTab: {
      type: String,
      default: 'dataSignal', 
    },
    
  },
  emits: ['closeModal'], 
  components: {
    customModal,
    Multiselect,
    discrepancyModal,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      headerValues: {},
      studyId: "",
      sdvData: [],
      sdvDataRef: [],      
      siteList: [],
      pageSize: 50,
      selectedSDV: {},
      sdvPayload: [],
      dataIndex: [],
      disabledIndex: [],
      selectedDataRefIDs: [],
      selectAllChecked: false,
      showDiscrepancyModal: false,
    };
  },
  async mounted() {
    this.studyId = store.getters.getStudyIs;
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    if(this.fromTab == 'dataSignal'){
      await this.getSDVDetails(this.id);
    }
    else{
      await this.getFormSDVDetails(this.id);
    }
    this.mapIndex();
    this.getSites();
  },
  watch: {
  },
  methods: {
    closeSDVModal() {
      this.$emit('closeModal');
    },
    async getSDVDetails(id){
      try{
        const responce = await axios.get(`${this.baseurl}/stats-python/formstatistics/getsdvbyid?SdvId=${id}`, this.headerValues);
        this.sdvDataRef = responce.data.Data;
        console.log("selectedSDV details are...", this.sdvDataRef);
      }
      catch(error){
        console.error("Error fetching SDV details:", error);
      }
    },
    async getFormSDVDetails(id){
      try{
        const response = await axios.get(`${this.baseurl}/forms/rbqm/getformsdvbyid?id=${id}`, this.headerValues);
        this.sdvData = response.data.data;
        console.log("selectedFormSDV details are...", response.data.data[0].fieldValue);
        this.sdvDataRef = this.sdvData.map(item => ({       
          DataRefID: item.dataRefID,
          SiteId: item.siteId,
          SiteCode: item.siteCode,
          SubjectId: item.subjectId,
          SubjectNo: item.subjectNo,
          VisitNo: item.visitNo,
          FormName: item.formName,
          FieldName: item.fieldName,
          FieldValue: item.fieldValue,
          Outcome: item.outcome,
          SDVStatus: item.sdvStatus,
          SDVVerificationComments: item.sdvVerificationComments,          
          DiscrepancyReason: item.discrepancyReason,
          SDVVerfiedDate: item.sdvVerifiedDate,
          SDVVerifiedUserID: item.sdvVerifiedUserID,
          SDVVerifiedEmail: item.sdvVerifiedEmail
        }));
        console.log("selectedSDV details are...", this.sdvDataRef);
      }
      catch(error){
        console.error("Error fetching SDV details:", error);
      }
    },
    async getSites(){
      try{
        const responce = await axios.get(`${this.baseurl}/management/site/getallsitesbyuser?studyId=${this.studyId}&getAll=false`, this.headerValues);
        this.siteList = responce.data;
      }
      catch(error){
        console.error("Error fetching sites:", error);
      }
    },
    async mapIndex(){
      this.dataIndex = [];
      this.disabledIndex = [];
      this.sdvDataRef.forEach((data, index) => {
        if(data.SDVStatus  == 'Completed' || data.SDVStatus === 'Discrepant'){
          this.dataIndex.push(true);
          this.disabledIndex.push(index);
        }
        else{
          this.dataIndex.push(false);
        }
      });
    },
    async verifySourceData(){
      try{
        const result = await axios.put(`${this.baseurl}/forms/rbqm/updatesdvitem`,this.sdvPayload,this.headerValues);
        alert(this.$t('navigations.submitted successfully'));
        console.log("verify source data result", result);
      }
      catch(error){
        console.error("Error in verify source data:", error);
      }
    },
    async verifyRow(row, action){ 
      await this.mapRow(row, action);
      await this.verifySourceData();
      if(this.fromTab == 'dataSignal'){
      await this.getSDVDetails(this.id);
    }
    else{
      await this.getFormSDVDetails(this.id);
    }
    },
    async discrepantRow(row){
      await this.mapRow(row, 'Discrepancy');
      this.showDiscrepancyModal = true;
    },
    async verifySelected(){
      if (confirm(this.$t(`navigations.are you sure you want to verify all selected data?`))) {
        await this.mapMultipleRows('Verified');
        await this.verifySourceData();
        await this.getSDVDetails(this.id);
      }
    },
    async discrepantSelected(){
      if (confirm(this.$t(`navigations.are you sure you want to mark as discrepant for all selected data?`))) {
        await this.mapMultipleRows('Discrepancy');
        this.showDiscrepancyModal = true;
      }
    },
    async mapRow(row,action){
      this.sdvPayload = {
        id: this.id,
        dataRefID: [String(row.DataRefID)],
        outcome: action,
        sdvStatus: action == "Verified" ?  "Completed" : action == "Discrepancy" ? "Discrepant" : "",
        discrepancyReason: "",
        sdvVerificationComments: ""
      }
    },
    async selectRow(row, index){
      if(this.dataIndex[index] == false){
       this.selectedDataRefIDs.push(row.DataRefID);
      }
      else{
        const idx = this.selectedDataRefIDs.indexOf(row.DataRefID);
        if (idx !== -1) {
          this.selectedDataRefIDs.splice(idx, 1);
        }
      }
    },
    async mapMultipleRows(action){
      this.sdvPayload = {
        id: this.id,
        dataRefID: this.selectedDataRefIDs, 
        outcome: action,
        sdvStatus: action == "Verified" ?  "Completed" : action == "Discrepancy" ? "Discrepant" : "",
        discrepancyReason: "",
        sdvVerificationComments: ""
      }
    },
    async SelectAll() {
      this.selectedDataRefIDs = [];
        if (this.selectAllChecked === false) {
          this.dataIndex.forEach((_, index) => {
            if(!this.disabledIndex.includes(index)){
              this.dataIndex[index] = false;
            }
          });
          
        } else {
          this.dataIndex.forEach((_, index) => {
            if (!this.disabledIndex.includes(index)) {
              this.dataIndex[index] = true;
            }
          });
          this.sdvDataRef.forEach((ref, index) => {
            if (!this.disabledIndex.includes(index)) {
              this.selectedDataRefIDs.push(ref.DataRefID);
            }
          });
        }
    },
    async closeDiscrepancy(){
      if(this.fromTab == 'dataSignal'){
      await this.getSDVDetails(this.id);
    }
    else{
      await this.getFormSDVDetails(this.id);
    }
    this.showDiscrepancyModal = false;
       
    },
    arrayToCommaString(arr) {
      if (!Array.isArray(arr)) return '';
      return arr.join(', ');
    }

  },
  computed: {
    hasPendingItems() {
      try {
        return Array.isArray(this.sdvDataRef) && this.sdvDataRef.some(r => r.SDVStatus === 'Pending');
      } catch (e) {
        return false;
      }
    }
  },
};
